import 'core-js';
import 'regenerator-runtime';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
/* tslint:disable */
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { App } from './containers/app';
import { ErrorPage, SuccessPage } from './components';
import {BaseApi} from "@logicmanager/common";
import * as BUILD from "../config/config";
import './index.app.less';

BaseApi.configure({ baseUrl: BUILD.BASE_URL });
ReactDOM.render(
  <BrowserRouter>
      <Switch>
          {/*<Route path="/:testId/:planId/:key" component={App} />*/}
          <Route path="/error" component={ErrorPage} />
          <Route path="/incidents" component={App} />
          <Route path="/success" component={SuccessPage} />
      </Switch>
  </BrowserRouter>,
  document.getElementById('app-root')
);
